import React from "react";
import { GetStaticProps, NextPage } from "next";
import dynamic from "next/dynamic";
import { FrontAuthProps, withFrontAuth } from "lib/hoc/withFrontAuth";
import Main from "components/front/layout/Main";
import RootSection from "components/front/layout/RootSection";
import GeneralHead from "components/front/head/GeneralHead";
import { Header } from "components/front/layout/Header";
import { Props as FooterProps } from "../components/front/layout/Footer";
import { Props as GeneralFootProps } from "components/front/layout/GeneralFoot";
import { Props as LegalSectionProps } from "components/front/legal/LegalSection";

const LegalSection = dynamic<LegalSectionProps>(() => import("components/front/legal/LegalSection"));
const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));
const GeneralFoot = dynamic<GeneralFootProps>(() => import("components/front/layout/GeneralFoot").then((m) => m.GeneralFoot));

type Props = {};
const LegalPage: NextPage<Props & FrontAuthProps> = () => (
  <>
    <GeneralHead screenName="特定商取引法に基づく表記" />
    <Header />
    <Main>
      <RootSection>
        <LegalSection />
      </RootSection>
    </Main>
    <Footer />
    <GeneralFoot />
  </>
);
export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {},
  };
};
export default withFrontAuth(LegalPage);
